import { render, staticRenderFns } from "./authDepartment.vue?vue&type=template&id=0a6f5250"
import script from "./authDepartment.vue?vue&type=script&lang=js"
export * from "./authDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports